import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import TopicsSection from "./components/TopicsSection";
import EpisodesSection from "./components/EpisodesSection";
import CoursesSection from "./components/CoursesSection";
import NewsletterSection from "./components/NewsletterSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";
import AuthPage from "./pages/AuthPage";
import AuthCallback from "./pages/AuthCallback";
import QuizPage from "./pages/QuizPage";
import CoursePage from "./pages/CoursePage";
import CheckoutPage from "./pages/CheckoutPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";

const LandingPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <TopicsSection />
        <EpisodesSection />
        <CoursesSection />
        <NewsletterSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

// Router component that handles auth callback detection
function AppRouter() {
  const location = useLocation();
  
  // Check URL hash for session_id synchronously during render (prevents race conditions)
  // This must happen BEFORE any route checking
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/quiz" element={<QuizPage />} />
      <Route path="/course" element={<CoursePage />} />
      <Route path="/course/checkout" element={<CheckoutPage />} />
      <Route path="/course/success" element={<PaymentSuccessPage />} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
